var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Grid, Stepper, Step, StepLabel, StepContent, Typography, Box, IconButton, } from '@mui/material';
import { EditIcon, DeleteIcon } from '../atoms/Icons';
import { weightFormat } from '../../utils/format';
import MaterialTable from '../MaterialTable';
var QontoStepIconRoot = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  height: 22px;\n  align-items: center;\n  & > .QontoStepIcon-circle {\n    width: 8px;\n    height: 8px;\n    margin-left: 8px;\n    border-radius: 50%;\n    background-color: currentColor;\n  }\n"], ["\n  display: flex;\n  height: 22px;\n  align-items: center;\n  & > .QontoStepIcon-circle {\n    width: 8px;\n    height: 8px;\n    margin-left: 8px;\n    border-radius: 50%;\n    background-color: currentColor;\n  }\n"])));
var DeliveryRequestItems = function (_a) {
    var itemsAndRequestDates = _a.itemsAndRequestDates, handleEditItemsAndRequestDate = _a.handleEditItemsAndRequestDate, handleDeleteItemsAndRequestDate = _a.handleDeleteItemsAndRequestDate;
    var t = useTranslation().t;
    return (React.createElement(Stepper, { orientation: "vertical", sx: { mb: 1 } }, itemsAndRequestDates.map(function (itemsAndRequestDate) {
        return (React.createElement(Step, { key: itemsAndRequestDate.key, active: true, expanded: true },
            React.createElement(StepLabel, { StepIconComponent: function () { return (React.createElement(QontoStepIconRoot, null,
                    React.createElement("div", { className: "QontoStepIcon-circle" }))); } },
                React.createElement(Grid, { container: true, direction: "row", alignItems: "center", spacing: 4 },
                    React.createElement(Grid, { item: true, xs: 7 },
                        React.createElement(Typography, null, "".concat(t('labels.deliveryRequestFormRequestDate'), ": ").concat(itemsAndRequestDate.requestDate ||
                            t('labels.fastestDeliveryRequest')))),
                    React.createElement(Grid, { item: true, xs: 5 },
                        React.createElement(Box, { display: "flex", justifyContent: "end", alignItems: "right", width: "100%" },
                            itemsAndRequestDates.length > 1 && (React.createElement(IconButton, { color: "secondary", size: "small", onClick: function () {
                                    return handleDeleteItemsAndRequestDate(itemsAndRequestDate);
                                }, sx: { mr: 1 } },
                                React.createElement(DeleteIcon, null))),
                            React.createElement(IconButton, { color: "secondary", size: "small", onClick: function () {
                                    return handleEditItemsAndRequestDate(itemsAndRequestDate);
                                } },
                                React.createElement(EditIcon, null)))))),
            React.createElement(StepContent, null,
                React.createElement(MaterialTable, { model: 'deliveryRequestItem', title: '', columns: [
                        {
                            title: t('params.offer.lotNumber'),
                            render: function (_a) {
                                var lotNumber = _a.lotNumber;
                                return lotNumber;
                            },
                        },
                        {
                            field: 'quantity',
                            render: function (_a) {
                                var quantity = _a.quantity, bagSize = _a.bagSize;
                                return "".concat(quantity, "(").concat(weightFormat(parseFloat(bagSize) * quantity), ")");
                            },
                        },
                    ], data: itemsAndRequestDate.itemsAttributes, options: { minBodyHeight: 100 } }))));
    })));
};
export default DeliveryRequestItems;
var templateObject_1;
